@switch (layout()) {
  @case ('empty') {
    <fc-empty-layout />
  }
  @case ('default') {
    <fc-default-layout />
  }
  @default {
    <fc-preloader />
  }
}